import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "className", "alignItems", "alignContent", "style", "direction", "justifyContent"],
  _excluded2 = ["children", "className", "stretch", "vcentered"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import './styles.sass';

/**
 * Flex container - use this instead of bulma columns when you don't want the extra
 * cruft of the bulma grid.
 */
export var FlexContainer = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
    className = _ref.className,
    alignItems = _ref.alignItems,
    alignContent = _ref.alignContent,
    style = _ref.style,
    direction = _ref.direction,
    justifyContent = _ref.justifyContent,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: cx('FlexContainer', className),
    style: _objectSpread({
      alignItems: alignItems,
      flexDirection: direction,
      justifyContent: justifyContent,
      alignContent: alignContent
    }, style)
  }, props, {
    ref: ref
  }), children);
});
FlexContainer.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  style: PropTypes.object,
  direction: PropTypes.oneOf(['row', 'row-reverse', 'column', 'column-reverse', 'initial', 'inherit']),
  alignContent: PropTypes.oneOf(['stretch', 'center', 'flex-start', 'flex-end', 'space-between', 'space-around', 'initial', 'inherit']),
  alignItems: PropTypes.oneOf(['stretch', 'center', 'flex-start', 'flex-end', 'baseline', 'initial', 'inherit']),
  justifyContent: PropTypes.oneOf(['flex-start', 'flex-end', 'center', 'space-between', 'space-around', 'initial', 'inherit'])
};

/**
 * Flex item.
 */
export var FlexItem = /*#__PURE__*/React.forwardRef(function (_ref2, ref) {
  var children = _ref2.children,
    className = _ref2.className,
    stretch = _ref2.stretch,
    vcentered = _ref2.vcentered,
    props = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: cx('FlexItem', {
      'FlexItem--stretch': stretch,
      'FlexItem--vcentered': vcentered
    }, className)
  }, props, {
    ref: ref
  }), children);
});
FlexItem.propTypes = {
  className: PropTypes.string,
  stretch: PropTypes.bool,
  children: PropTypes.node,
  vcentered: PropTypes.bool
};
//# sourceMappingURL=index.js.map
